import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function AddIftaEntryModal({
  show,
  onClose,
  onSubmit,
  QUARTERLY_RATES,
  isLoading,
  initialData = null, // 👈 NEW
}) {
  const [state, setState] = useState("");
  const [miles, setMiles] = useState("0");
  const [gallons, setGallons] = useState("0");
  const [taxRate, setTaxRate] = useState("");

  useEffect(() => {
    if (initialData) {
      setState(initialData.tax_rate_id || "");
      setMiles(initialData.miles?.toString() || "0");
      setGallons(initialData.taxPaidGallons?.toString() || "0");
    } else {
      setState("");
      setMiles("0");
      setGallons("0");
    }
  }, [initialData]);

  const rate = useMemo(() => {
    return QUARTERLY_RATES?.find((r) => r.id?.toString() === state.toString());
  }, [state, QUARTERLY_RATES]);

  const handleSubmit = () => {
    if (!state) return;

    onSubmit({
      ...initialData,
      jurisdiction: state,
      miles: miles === "" ? "0" : miles,
      taxPaidGallons: gallons === "" ? "0" : gallons,
    });

    setState("");
    setMiles("0");
    setGallons("0");
    setTaxRate("");
  };
  const handleClose = () => {
    setState("");
    setMiles("0");
    setGallons("0");
    setTaxRate("");
    onClose();
  };

  console.log({ rate });

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Edit IFTA Entry" : "Add IFTA Entry"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* State */}
        <div className="mb-3">
          <label className="form-label fw-bold">State / Jurisdiction</label>
          <select
            className="form-select"
            value={state}
            onChange={(e) => setState(e.target.value)}
            disabled={!!initialData}
          >
            <option value="">Select State</option>
            {QUARTERLY_RATES.map((item) => (
              <option key={item.id} value={item.id}>
                {item.state_code} – {item.state_name}
              </option>
            ))}
          </select>
        </div>

        {/* Miles */}
        <div className="mb-3">
          <label className="form-label fw-bold">Miles</label>
          <input
            type="number"
            className="form-control"
            value={miles}
            onFocus={() => {
              if (miles === "0") setMiles("");
            }}
            onBlur={() => {
              if (miles === "") setMiles("0");
            }}
            onChange={(e) => setMiles(e.target.value)}
          />
        </div>

        {/* Gallons */}
        <div className="mb-3">
          <label className="form-label fw-bold">Tax Paid Gallons</label>
          <input
            type="number"
            className="form-control"
            value={gallons}
            onFocus={() => {
              if (gallons === "0") setGallons("");
            }}
            onBlur={() => {
              if (gallons === "") setGallons("0");
            }}
            onChange={(e) => setGallons(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Tax Paid Gallons</label>
          <input
            type="number"
            className="form-control"
            value={taxRate || rate?.rate}
            disabled
            // onChange={(e) => setGallons(e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Saving...
            </>
          ) : initialData ? (
            "Save Changes"
          ) : (
            "Add Entry"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
